module.exports = __webpack_public_path__ + "img/bisect.3d19d69f.svg";